import VueRouter from "vue-router";
import i18n from "../utils/i18n";
import loginView from "@/views/Login";

export const baseRoutes = [
  {
    path: "/login",
    name: "login",
    component: loginView,
    meta: { title: i18n.t("login.login") } //登录不适用懒加载
  }
];

const createRouter = () =>
  new VueRouter({
    mode: "history", // 把hash模式改成history nginx location / {try_files $uri $uri/ /index.html;}
    base: process.env.BASE_URL,
    routes: baseRoutes
  });

// 实例化
const router = createRouter();

export const resetRouter = () => {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher;
};

export default router;
